import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { connect } from 'react-redux';
import { makeStyles, TableContainer, Table, TableBody, TableRow, TableCell, Typography } from '@material-ui/core';

import Tab from 'src/components/tab';

import { setTabExpend } from './slice';

const rows = {
  'Organic search': { connected: 72.4, tagged: 60.0 },
  BSD: { connected: 72.4, tagged: 60.0 },
  'Social - Plaid Facebook': { connected: 72.4, tagged: 60.0 },
  'Plaid search - Google': { connected: 72.4, tagged: 60.0 },
  'Pay per click ads': { connected: 72.4, tagged: 60.0 },
  'Contact form 7': { connected: 72.4, tagged: 60.0 },
  'Direct traffic': { connected: 72.4, tagged: 60.0 },
  'Organic - short form': { connected: 72.4, tagged: 60.0 },
  'Unknown (not assigned)': { connected: 72.4, tagged: 60.0 },
};

const useStyles = makeStyles(theme => ({
  tableBody: {
    '& > *:last-child > *': {
      borderWidth: 0,
    },
  },
}));

const SourceOfLeads = props => {
  const { isTabExpended } = props;
  const classes = useStyles();

  const prismicContent = useStaticQuery(graphql`
    query {
      allPrismicOverview {
        edges {
          node {
            data {
              title3 {
                html
                text
                raw
              }
              titleTooltip3 {
                html
                text
                raw
              }
            }
          }
        }
      }
    }
  `);

  const prismicData = prismicContent.allPrismicOverview.edges[0].node.data;

  const handelExpand = () => {
    props.setTabExpend(!isTabExpended);
  };

  return (
    <Tab
      title={prismicData.title3.text}
      tooltipedText={prismicData.titleTooltip3.text}
      drag
      onClick={handelExpand}
      expanded={isTabExpended}
    >
      <TableContainer>
        <Table>
          <TableBody className={classes.tableBody}>
            {Object.keys(rows).map(key => (
              <TableRow key={key}>
                <TableCell align="left">
                  <Typography>{key}</Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography>
                    <b>{rows[key].connected}%</b> connected rate
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography>
                    <b>{rows[key].tagged}%</b> call tagged
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Tab>
  );
};

const mapStateToProps = ({ me }) => {
  const { overview } = me;
  const { sourceOfLeads } = overview;
  return { ...sourceOfLeads };
};

const mapDispatchToProps = { setTabExpend };

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(SourceOfLeads));
